import React, {PureComponent} from 'react';
import {
  Col,
  Row,
  Grid,
  Image,
} from 'react-bootstrap';
import './AboutPage.css';

class AboutPage extends PureComponent {

  render() {

    return (
      <div className="AboutPage-container">
        <Grid>
          <Row>
            <Col sm={6} smOffset={0}>
              <Image src="/images/susan-payne-headshot.jpg" alt="Susan Payne Headshot" thumbnail />
            </Col>
            <Col sm={6} smOffset={0}>
              <div className="AboutPage-bio">
                <p>
                  Susan Payne O’Brien is deeply influenced by the rich theatrical landscape of the
                  Chicagoland area where she works and resides. She trained as a director and
                  performer under Byrne and Joyce Piven at the famed Piven Theater Workshop. Drawing
                  upon her twenty year tenure as a teacher, performer and director at Piven and upon
                  her years as an actress and opera singer Susan creates inventive work for the
                  theater and opera stage.
                </p>
                <p>
                  She is the founder and Artistic Director of Forte Chicago,
                  an all female operatic company that devises new work pushing the boundaries of the
                  female voice. Since Forte’s launch in 2015 it has premiered five full length
                  original devised shows exposing fresh audiences to the possibilities and delight of
                  opera. Susan is passionate about bringing theatrical devising process to opera
                  classrooms and has served on the directing and opera faculties of Roosevelt
                  University, DePaul University and North Park University. She has directed, written
                  and devised shows for The Piven Theater Lab, Black Cat Theater, 2nd Story, Links
                  Hall, The Santa Fe Opera, The El Paso Opera, Artemesia, and the CUBE Ensemble.
                </p>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/containers/AboutPage.jsx